module.exports = __webpack_public_path__ + "img/chrismcleod.61691ee9.png";